import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">3.0.10 Case 10</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="self_assessment_110"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is self-assessment case number one, one, zero, or 110. This
                is a positive case. Beginning at the level of the inferior
                temporal lobes, seen here and here, and moving superiorly, white
                matter tracts may be identifiable at this level on the left-hand
                side. However, scrolling superiorly, it is clear that increased
                activity is seen extending to the cortical rim and within the
                gray matter of the left temporal lobe. On the right-hand side,
                similarly, there is reduced gray-white contrast identified at
                this level. Although white matter tracts may be delineated
                superiorly, overall, there remains loss of gray-white contrast
                in the right temporal lobe as well. Therefore, the temporal
                lobes are positive for reduced, but not absent, gray-white
                contrast. Moving anteriorly, to the frontal regions, the right
                frontal cortex shows reduced gray-white contrast throughout.
                White matter tracts are not identifiable, and there is increased
                activity within the gray matter. On the left-hand side, although
                these focal areas may suggest white matter uptake, there is no
                distinct white matter pattern, and, therefore, there is reduced
                gray-white contrast throughout. Once again moving superiorly,
                there is a hint of a white matter tract seen on the left-hand
                side. However, the tract does not proceed all the way to the
                posterior brain. And on the right-hand side, the white matter
                tract is not clearly identifiable. As we enter into the medial
                parietal region, seen here, increased activity is seen within
                the midline. Further localization on the sagittal images shows
                increased activity throughout the medial parietal region,
                including the precuneus, as seen here. In addition, at this
                level, there is loss of gray-white contrast in the posterior
                aspect of the parietal region as well. Focal uptake, seen here,
                is also within the medial parietal region and can be identified
                further on the sagittal images. A review of all of the slices in
                the scan continue to show that there is loss of gray-white
                contrast within the parietal, temporal, and frontal region.
                Therefore, this scan is positive. I invite you to review the
                case once again in the MIM Viewer if you called this case
                negative.
              </p>
            </>
          }
          previousLesson="/module-3/module-3-0-9"
          nextLesson="/module-3/module-3-0-11"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1239246398&entry_id=1_ypuxbgmj&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          questionType="assessment"
          videoId="1_ypuxbgmj"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
